import type { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { EmptyState } from '@xdocs/ui';
import { useAdminT } from './useAdminT.js';

/**
 * 403 state for the role-gated admin section (F68/§15.2). Rendered by
 * `RoleGate` when the signed-in user's role doesn't satisfy the route's
 * minimum — never a blank page or a silent redirect, per ux.md's error-state
 * contract (human cause + a recovery action).
 */
export function Forbidden(): ReactElement {
  const { t } = useAdminT();
  const navigate = useNavigate();

  return (
    <EmptyState
      kind="error"
      title={t('admin:forbidden.title')}
      description={t('admin:forbidden.description')}
      action={{ label: t('admin:forbidden.cta'), onClick: () => void navigate('/') }}
    />
  );
}
